export default "__VITE_ASSET__a7Op412s__"